module.exports = __webpack_public_path__ + "static/img/three-d-icon.2a73fea5.png";